import { userManageListeners } from '@/features/admin/userManage';
import type { AppDispatch, State } from '@/store';
import { addListener, createListenerMiddleware } from '@reduxjs/toolkit';

export const listenerMiddleware = createListenerMiddleware();

export const startListening =
  listenerMiddleware.startListening.withTypes<State, AppDispatch>();
export const addAppListener = addListener.withTypes<State, AppDispatch>();

export type AppStartListening = typeof startListening;
export type AppAddListener = typeof addAppListener;

userManageListeners(startListening);
